import React, {useEffect, useState} from 'react';
import './style.scss';
import {Button, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import ProPortalHeader from "../../componets/ProPortalHeader";
import ProfileRow from "../../componets/ProfileRow";
import Navigator from "../../componets/Navigator";


const MainContent = () => {
    // 初始视频ID
    const initialVideoId = 'JxQbY7KkQhY';
    // 使用useState来跟踪当前选中的视频ID
    const [currentVideoId, setCurrentVideoId] = useState(initialVideoId);
    // 视频ID数组，每个按钮对应一个ID
    const videoIds = {
        tutorial1: 'ua2KTSpgTYY',
        tutorial2: '8BgRHPt6vSE',
        tutorial3: 'kq1upWekTPk',
        tutorial4: 'NKY_Uq-f5TU',
        tutorial5: 'fWfLcWXBytQ',
    };
    // 更新视频ID的函数
    const updateVideo = (videoId) => {
        setCurrentVideoId(videoId);
    };

    return (
        <div className='ProTutorial'>
            <p className='ProTutorial-title'>Getting Started Video</p>
            <iframe className="ProTutVideo"
                    width="660"
                    height="415"
                    src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=1`} // 添加 autoplay 参数
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
            ></iframe>
            <div className="video-controls">
                <Button className="PortalTut1" onClick={() => updateVideo(videoIds.tutorial1)}>Pairing your
                    Textura</Button>
                <Button className="PortalTut2" onClick={() => updateVideo(videoIds.tutorial2)}>Control multiple
                    hardware</Button>
                <Button className="PortalTut3" onClick={() => updateVideo(videoIds.tutorial3)}>Create Playlists</Button>
                <Button className="PortalTut4" onClick={() => updateVideo(videoIds.tutorial4)}>Upgrade your
                    subscription</Button>
                <Button className="PortalTut5" onClick={() => updateVideo(videoIds.tutorial5)}>Publish &
                    Preview</Button>
            </div>
        </div>
    );
};
const ProTutorial = () => {
    return (
        <Layout>
            <Content>
                <ProPortalHeader/>
                <ProfileRow/>
                <Row justify={"center"}>
                    <Layout>
                        <Navigator/>
                        <Layout>
                            <MainContent/>
                        </Layout>
                    </Layout>
                </Row>
            </Content>
        </Layout>
    )
}
export default ProTutorial;